import React from 'react';
import styles from './styles';
import { mergeStyles } from '../../utils/mergeStyles';
import { AvatarSizes } from '../avatar';
import { ClearIcon } from '../icons';
import { CompanyAvatar, UserAvatar, ContactAvatar } from '../avatar';
import {
    COMPANIES,
    CONTACTS,
    SALES_FORCE,
    OPPORTUNITIES,
    BILLBOARD,
    USERS,
} from '../../constants/Entities';
import DetailDecorator from '../../decorators/DetailDecorator';

import Context from '../../managers/Context';

export const Chip = ({ children, style, onClick }) => {
    let cStyle = mergeStyles(styles.content, style);
    let classes = ['chip'];
    if (!onClick) classes.push('chip-no-clickable');
    return (
        <div className={classes.join(' ')} style={cStyle} onClick={onClick ? onClick : undefined}>
            {children}
        </div>
    );
};

export const ChipSizes = {
    SMALL: { avatar: AvatarSizes.SMALL, styleOneLine: {} },
    NORMAL: { avatar: AvatarSizes.NORMAL, styleOneLine: {} },
    BIG: { avatar: AvatarSizes.BIG, styleOneLine: {} },
    EXTRABIG: {
        avatar: AvatarSizes.EXTRABIG,
        styleOneLine: { marginTop: 7 },
        styleTwoLine: { marginTop: 7 },
    },
    NONE: { avatar: AvatarSizes.NONE, styleOneLine: {} },
};

const parseSize = (size) => {
    switch (size) {
        case ChipSizes.SMALL:
            return AvatarSizes.SMALL;
            break;
        case ChipSizes.NORMAL:
            return AvatarSizes.NORMAL;
            break;
        case ChipSizes.BIG:
            return AvatarSizes.BIG;
            break;
        case ChipSizes.EXTRABIG:
            return AvatarSizes.EXTRABIG;
            break;
        case ChipSizes.NONE:
            return AvatarSizes.NONE;
            break;
        default:
            return AvatarSizes.NORMAL;
            break;
    }
};

export const DefaultChip = ({
    avatar,
    name,
    subTitle,
    style,
    onClick,
    right,
    size,
    styleTitle,
    clearStyle,
    onCancel,
    onTouchTap,
    removeMargin,
}) => {
    let _size = size ? size : ChipSizes.NORMAL;
    let rightStyle = right ? styles.rightStyle : {};
    name = Context.utilsFormats.unescapeHTML(name);
    subTitle = subTitle ? Context.utilsFormats.unescapeHTML(subTitle) : subTitle;
    let desc = subTitle ? (
        <div style={mergeStyles(styles.contentDivTextTwoLines, _size.styleTwoLine)}>
            <div style={mergeStyles(styles.block, styleTitle)}>{name}</div>
            <div style={styles.blockWithColor}>{subTitle}</div>
            {close}
        </div>
    ) : (
        <div style={mergeStyles(styles.contentDivText, _size.styleOneLine)}>
            <span style={mergeStyles(mergeStyles(rightStyle, styles.minusMarginLeft), styleTitle)}>
                {name}
            </span>
        </div>
    );
    let close = onCancel ? (
        <div style={{ ...styles.inlineBlock, verticalAlign: 'middle', height: '20px' }}>
            <ClearIcon
                style={{ ...styles.clearButton, ...clearStyle }}
                onClick={(e) => {
                    e.stopPropagation();
                    onCancel();
                }}
            />
        </div>
    ) : null;
    style = onClick ? { ...style, cursor: 'pointer' } : style;
    return right ? (
        <Chip style={mergeStyles(styles.textAlignRight, style)} onClick={onClick}>
            {desc}
            {avatar ? (
                <div
                    style={{
                        ...styles.inlineBlock,
                        marginTop: removeMargin ? '0px' : '-1px',
                        verticalAlign: 'middle',
                        borderRadius: '16px',
                        height: _size.avatar.height,
                        width: _size.avatar.width,
                    }}
                >
                    {avatar}
                </div>
            ) : (
                <div style={styles.inlineBlock}>{avatar}</div>
            )}
            {close}
        </Chip>
    ) : (
        <Chip style={mergeStyles({ background: '' }, styles.inlineBlock, style)} onClick={onClick}>
            {avatar ? (
                <div
                    style={{
                        ...styles.inlineBlock,
                        marginTop: removeMargin ? '0px' : '-1px',
                        verticalAlign: 'middle',
                        borderRadius: '16px',
                        height: _size.avatar.height,
                        width: _size.avatar.width,
                    }}
                >
                    {avatar}
                </div>
            ) : (
                <div style={styles.inlineBlock}>{avatar}</div>
            )}
            {desc}
            {close}
        </Chip>
    );
};

export const EntityChip = ({
    clearStyle,
    configEntity,
    id,
    name,
    subTitle,
    errorText,
    style,
    styleTitle,
    right,
    onClick,
    size,
    onCancel,
    iconStyle,
    removeMargin,
    cacheBrowser,
}) => {
    let props = {
        clearStyle: clearStyle,
        id: id,
        name: name,
        style: style,
        onClick: onClick,
        subTitle: subTitle,
        onCancel: onCancel,
        errorText: errorText,
        size: size,
        right: right,
        styleTitle: styleTitle,
        iconStyle: iconStyle,
        removeMargin: removeMargin,
        cacheBrowser,
    };

    switch (configEntity.entity) {
        case COMPANIES.entity:
            return <CompanyChipNoClick {...props} />;
        case CONTACTS.entity:
            return <ContactChipNoClick {...props} />;
        case USERS.entity:
        case SALES_FORCE.entity:
            return <UserChip {...props} />;
        case OPPORTUNITIES.entity:
            return <OpportunityChipNoClick {...props} />;
        case BILLBOARD.entity:
            return <UserChip {...props} />;
        default:
            return <CompanyChip {...props} />;
    }
};

export const CompanyChipNoClick = ({
    id,
    name,
    subTitle,
    style,
    right,
    onClick,
    size,
    styleTitle,
    onCancel,
    clearStyle,
    removeMargin,
    cacheBrowser,
}) => {
    return (
        <DefaultChip
            clearStyle={clearStyle}
            avatar={<CompanyAvatar id={id} size={parseSize(size)} cacheBrowser={cacheBrowser} />}
            size={size}
            onClick={onClick}
            right={right}
            name={name}
            subTitle={subTitle}
            style={style}
            styleTitle={styleTitle}
            onCancel={onCancel}
            removeMargin={removeMargin}
        />
    );
};

export const UserChip = ({
    id,
    name,
    subTitle,
    style,
    right,
    onClick,
    size,
    styleTitle,
    onCancel,
    clearStyle,
    removeMargin,
}) => (
    <DefaultChip
        clearStyle={clearStyle}
        avatar={<UserAvatar id={id} size={parseSize(size)} />}
        size={size}
        onClick={onClick}
        right={right}
        name={name}
        subTitle={subTitle}
        style={style}
        styleTitle={styleTitle}
        onCancel={onCancel}
        removeMargin={removeMargin}
    />
);

export const ContactChipNoClick = ({
    id,
    name,
    subTitle,
    style,
    right,
    onClick,
    size,
    errorText,
    styleTitle,
    onCancel,
    iconStyle,
    clearStyle,
}) => (
    <DefaultChip
        clearStyle={clearStyle}
        avatar={
            <ContactAvatar
                id={id}
                size={parseSize(size)}
                errorText={errorText ? errorText : name.substring(0, 2)}
                style={iconStyle}
            />
        }
        size={size}
        right={right}
        onClick={onClick}
        name={name}
        subTitle={subTitle}
        style={style}
        styleTitle={styleTitle}
        onCancel={onCancel}
    />
);

export const OpportunityChipNoClick = ({
    name,
    subTitle,
    style,
    right,
    onClick,
    size,
    styleTitle,
    onCancel,
    iconStyle,
    clearStyle,
}) => (
    <DefaultChip
        clearStyle={clearStyle}
        right={right}
        onClick={onClick}
        name={name}
        subTitle={subTitle}
        style={style}
        styleTitle={styleTitle}
        onCancel={onCancel}
    />
);

export const SvgChip = ({ text, svg, style, onClick, size, styleTitle }) => {
    return (
        <DefaultChip
            avatar={svg}
            size={size}
            onClick={onClick}
            name={text}
            style={style}
            styleTitle={styleTitle}
        />
    );
};

export const ValueListChip = ({ name, style, onClick, size, styleTitle, onCancel, clearStyle }) => {
    return (
        <DefaultChip
            clearStyle={clearStyle}
            size={size}
            onClick={onClick}
            onCancel={onCancel}
            name={name}
            style={style}
            styleTitle={styleTitle}
        />
    );
};

export const ContactChip = DetailDecorator(CONTACTS)(ContactChipNoClick);
export const CompanyChip = DetailDecorator(COMPANIES)(CompanyChipNoClick);
export const OpportunityChip = DetailDecorator(OPPORTUNITIES)(OpportunityChipNoClick);
